import { Badge } from '@shared/components/ui/badge';
import { cn } from '@shared/utils/utils';

/** Borde del chip; el punto solo aporta color (sin anillo). */
const UNIFIED_BADGE =
  'border border-border bg-transparent px-2 py-0.5 shadow-none text-foreground gap-1.5 font-medium hover:bg-transparent';

export function StatusBadgeWithDot({
  label,
  dotClassName,
  className,
}: {
  label: string;
  dotClassName: string;
  className?: string;
}) {
  return (
    <Badge variant="outline" className={cn(UNIFIED_BADGE, className)}>
      <span className={cn('size-2 shrink-0 rounded-full', dotClassName)} aria-hidden />
      {label}
    </Badge>
  );
}
